/* ============================================================
   MY RARE AURA — PHASE 6 WISHLIST SYSTEM
   File: assets/aurelle-wishlist.js

   What this file controls:
   1. Wishlist localStorage persistence
   2. Wishlist page rendering
   3. Remove single item
   4. Clear wishlist
   5. Add single item to cart
   6. Add all available items to cart
   7. Share wishlist
   8. Header wishlist counter
   9. Safe sync with product/collection wishlist buttons
   ============================================================ */

(function () {
  'use strict';

  /* ================= CONFIG ================= */
  var KEY = 'aurelleWishlist';
  var LEGACY_KEYS = ['aurelle_wishlist', 'house_of_aurelle_wishlist'];
  var MAX_ITEMS = 80;

  /* ================= DOM HELPERS ================= */
  function qs(selector, root) {
    return (root || document).querySelector(selector);
  }

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function safeClosest(target, selector) {
    if (!target || typeof target.closest !== 'function') return null;
    return target.closest(selector);
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      })[char];
    });
  }

  /* ================= STORAGE ================= */
  function normalizeItem(item) {
    if (!item) return null;

    var id = item.id || item.productId || item.product_id || '';
    var variantId = item.variantId || item.variant_id || item.variant || '';

    if (!id && !variantId) return null;

    return {
      id: String(id || variantId),
      variantId: String(variantId || ''),
      title: item.title || item.productTitle || item.name || 'Product',
      url: item.url || item.href || '#',
      image: item.image || item.featured_image || item.src || '',
      price: item.price || item.priceText || ''
    };
  }

  function readWishlist() {
    var raw = localStorage.getItem(KEY);

    if (!raw) {
      LEGACY_KEYS.forEach(function (legacyKey) {
        if (!raw) raw = localStorage.getItem(legacyKey);
      });
    }

    var parsed = [];

    try {
      parsed = JSON.parse(raw || '[]');
    } catch (error) {
      parsed = [];
    }

    if (!Array.isArray(parsed)) parsed = [];

    var seen = {};
    var normalized = [];

    parsed.forEach(function (item) {
      var clean = normalizeItem(item);
      if (!clean) return;

      var uniqueKey = String(clean.id || clean.variantId);
      if (seen[uniqueKey]) return;

      seen[uniqueKey] = true;
      normalized.push(clean);
    });

    return normalized.slice(0, MAX_ITEMS);
  }

  function getSharedWishlistFromUrl() {
  var params = new URLSearchParams(window.location.search);
  var shared = params.get('share');

  if (!shared) return null;

  try {
    var decoded = decodeURIComponent(shared);
    var json = decodeURIComponent(escape(atob(decoded)));
    var items = JSON.parse(json);

    if (!Array.isArray(items)) return null;

    return items.map(normalizeItem).filter(Boolean).slice(0, MAX_ITEMS);
  } catch (error) {
    return null;
  }
}

  function writeWishlist(items) {
    var cleanItems = (items || [])
      .map(normalizeItem)
      .filter(Boolean)
      .slice(0, MAX_ITEMS);

    localStorage.setItem(KEY, JSON.stringify(cleanItems));

    LEGACY_KEYS.forEach(function (legacyKey) {
      localStorage.removeItem(legacyKey);
    });

    updateCounter(cleanItems.length);
    syncWishlistButtons(cleanItems);

    document.dispatchEvent(new CustomEvent('aurelle:wishlist-updated', {
      detail: {
        count: cleanItems.length,
        items: cleanItems
      }
    }));

    return cleanItems;
  }

  function removeItem(index) {
    var items = readWishlist();
    items.splice(Number(index), 1);
    writeWishlist(items);
    renderWishlistPage();
    showStatus('Item removed.');
  }

  function clearWishlist() {
    writeWishlist([]);
    renderWishlistPage();
    showStatus('Wishlist cleared.');
  }

  /* ================= HEADER COUNTER ================= */
  function ensureHeaderCounter() {
    var links = qsa(
      '[data-aurelle-wishlist-link], a[href*="wishlist"], a[aria-label*="Wishlist"], a[aria-label*="wishlist"]'
    );

    links.forEach(function (link) {
      if (!link || qs('[data-aurelle-wishlist-count]', link)) return;

      link.classList.add('aurelle-wishlist-header-link');

      var badge = document.createElement('span');
      badge.className = 'aurelle-wishlist-count';
      badge.setAttribute('data-aurelle-wishlist-count', '');
      badge.hidden = true;
      badge.textContent = '0';

      link.appendChild(badge);
    });
  }

  function updateCounter(count) {
    ensureHeaderCounter();

    var finalCount = typeof count === 'number' ? count : readWishlist().length;

    qsa('[data-aurelle-wishlist-count]').forEach(function (badge) {
      badge.textContent = finalCount;
      badge.hidden = finalCount === 0;
    });
  }

  /* ================= BUTTON SYNC ================= */
  function syncWishlistButtons(items) {
    var wishlist = items || readWishlist();

    qsa('[data-aurelle-product-id], [data-product-id]').forEach(function (button) {
      var id = button.dataset.aurelleProductId || button.dataset.productId;
      if (!id) return;

      var active = wishlist.some(function (item) {
        return String(item.id) === String(id);
      });

      if (
        button.matches(
          '[data-aurelle-wishlist], [data-aurelle-collection-wishlist], .aurelle-card-heart, .aurelle-wishlist, .aurelle-quickview-wishlist'
        )
      ) {
        button.classList.toggle('is-wished', active);

        if (button.textContent.trim() === '♡' || button.textContent.trim() === '♥') {
          button.textContent = active ? '♥' : '♡';
        }
      }
    });
  }

  /* ================= SHARE / IMPORT WISHLIST LINK ================= */

function encodeWishlist(items) {
  return btoa(unescape(encodeURIComponent(JSON.stringify(items || []))));
}

function decodeWishlist(value) {
  return JSON.parse(decodeURIComponent(escape(atob(value))));
}

function getWishlistShareUrl(items) {
  return (
    window.location.origin +
    window.location.pathname +
    '?share=' +
    encodeURIComponent(encodeWishlist(items))
  );
}

function importSharedWishlist() {
  var params = new URLSearchParams(window.location.search);
  var shared = params.get('share');

  if (!shared) return;

  try {
    var importedItems = decodeWishlist(decodeURIComponent(shared));

    if (Array.isArray(importedItems) && importedItems.length) {
      writeWishlist(importedItems);

      window.history.replaceState(
        {},
        '',
        window.location.pathname
      );

      showStatus('Shared wishlist imported.');
    }
  } catch (error) {
    showStatus('Unable to import wishlist.');
  }
}

function copyText(text) {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    return navigator.clipboard.writeText(text);
  }

  return new Promise(function (resolve, reject) {
    var textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';
    textarea.style.top = '-9999px';

    document.body.appendChild(textarea);
    textarea.select();

    try {
      var success = document.execCommand('copy');
      document.body.removeChild(textarea);

      if (success) {
        resolve();
      } else {
        reject();
      }
    } catch (error) {
      document.body.removeChild(textarea);
      reject(error);
    }
  });
}

function shareWishlist() {
  var items = readWishlist();

  if (!items.length) {
    showStatus('Add pieces before sharing your wishlist.');
    return;
  }

  var encoded = btoa(unescape(encodeURIComponent(JSON.stringify(items))));
  var shareUrl = window.location.origin + '/pages/wishlist?share=' + encodeURIComponent(encoded);

  if (navigator.share) {
    navigator.share({
      title: 'My My Rare Aura Wishlist',
      text: 'View my saved My Rare Aura pieces.',
      url: shareUrl
    }).catch(function () {
      window.prompt('Copy your wishlist link:', shareUrl);
    });
    return;
  }

  window.prompt('Copy your wishlist link:', shareUrl);
}

  /* ================= CART HELPERS ================= */
  function addVariantToCart(variantId, quantity) {
    if (!variantId) return Promise.reject(new Error('Missing variant ID'));

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: quantity || 1
      })
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to add item');
      return response.json();
    });
  }

  function openCartDrawerSafely() {
    var drawer = qs('cart-drawer');

    if (!drawer) return;

    if (typeof drawer.open === 'function') {
      try {
        drawer.open();
        return;
      } catch (error) {}
    }

    drawer.classList.add('active', 'animate');
    document.body.classList.add('overflow-hidden');
  }

  function addAllAvailable(button) {
    var items = readWishlist();
    var variants = items.map(function (item) {
      return item.variantId;
    }).filter(Boolean);

    if (!variants.length) {
      showStatus('No available variants found in this wishlist.');
      return;
    }

    setLoading(button, 'Adding…');

    variants.reduce(function (promise, variantId) {
      return promise.then(function () {
        return addVariantToCart(variantId, 1);
      });
    }, Promise.resolve())
      .then(function () {
        showStatus('Wishlist added to bag.');
        openCartDrawerSafely();
      })
      .catch(function () {
        showStatus('Some wishlist items could not be added.');
      })
      .finally(function () {
        resetLoading(button, 'Add All Available');
      });
  }

  /* ================= UI HELPERS ================= */
  function setLoading(button, text) {
    if (!button) return;

    button.dataset.originalText = button.dataset.originalText || button.textContent;
    button.disabled = true;
    button.textContent = text || 'Loading…';
  }

  function resetLoading(button, fallbackText) {
    if (!button) return;

    window.setTimeout(function () {
      button.disabled = false;
      button.textContent = button.dataset.originalText || fallbackText || 'Done';
    }, 1200);
  }

  function showStatus(message) {
    var status = qs('[data-aurelle-wishlist-status]');

    if (!status) {
      status = document.createElement('div');
      status.setAttribute('data-aurelle-wishlist-status', '');
      status.className = 'aurelle-wishlist-status';
      document.body.appendChild(status);
    }

    status.hidden = false;
    status.textContent = message || '';

    window.clearTimeout(showStatus.timer);

    showStatus.timer = window.setTimeout(function () {
      status.hidden = true;
      status.textContent = '';
    }, 3000);
  }

  /* ================= PAGE RENDERING ================= */
  function createCard(item, index) {
    var variantDisabled = item.variantId ? '' : ' disabled';

    return [
      '<article class="aurelle-wishlist-card" data-aurelle-wishlist-card data-index="' + index + '">',
        '<a href="' + escapeHtml(item.url) + '" class="aurelle-wishlist-card__image">',
          item.image
            ? '<img src="' + escapeHtml(item.image) + '" width="700" height="933" alt="' + escapeHtml(item.title) + '" loading="lazy">'
            : '',
        '</a>',
        '<div class="aurelle-wishlist-card__content">',
          '<p>My Rare Aura</p>',
          '<a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.title || 'Product') + '</a>',
          '<span>' + escapeHtml(item.price || '') + '</span>',
          '<div class="aurelle-wishlist-card__actions">',
            '<button type="button" data-aurelle-wishlist-add="' + escapeHtml(item.variantId || '') + '"' + variantDisabled + '>Add to Bag</button>',
            '<button type="button" data-aurelle-wishlist-remove="' + index + '">Remove</button>',
          '</div>',
        '</div>',
      '</article>'
    ].join('');
  }

  function renderWishlistPage() {
  var page = qs('[data-aurelle-wishlist-page]');
  if (!page) return;

  var grid = qs('[data-aurelle-wishlist-grid]', page);
  var empty = qs('[data-aurelle-wishlist-empty]', page);
  var toolbar = qs('[data-aurelle-wishlist-toolbar]', page);

  if (!grid) return;

  var sharedItems = getSharedWishlistFromUrl();
  var items = sharedItems || readWishlist();

  grid.innerHTML = '';

  if (sharedItems) {
    page.classList.add('is-shared-wishlist');

    var title = qs('h1', page);
    if (title) title.textContent = 'Shared Wishlist';

    var clearButton = qs('[data-aurelle-clear-wishlist]', page);
    if (clearButton) clearButton.hidden = true;
  }

  if (!items.length) {
    grid.hidden = true;
    if (toolbar) toolbar.hidden = true;
    if (empty) empty.hidden = false;
    page.classList.add('is-empty');
    return;
  }

  grid.hidden = false;
  if (toolbar) toolbar.hidden = false;
  if (empty) empty.hidden = true;
  page.classList.remove('is-empty');

  grid.innerHTML = items.map(createCard).join('');
}

  /* ================= EVENTS ================= */
  function bindEvents() {
    document.addEventListener('click', function (event) {
      var shareButton = safeClosest(event.target, '[data-aurelle-share-wishlist]');
      if (shareButton) {
        event.preventDefault();
        shareWishlist();
        return;
      }

      var removeButton = safeClosest(event.target, '[data-aurelle-wishlist-remove]');
      if (removeButton) {
        event.preventDefault();
        removeItem(removeButton.dataset.aurelleWishlistRemove);
        return;
      }

      var addButton = safeClosest(event.target, '[data-aurelle-wishlist-add]');
      if (addButton) {
        event.preventDefault();

        if (!addButton.dataset.aurelleWishlistAdd || addButton.disabled) return;

        setLoading(addButton, 'Adding…');

        addVariantToCart(addButton.dataset.aurelleWishlistAdd, 1)
          .then(function () {
            addButton.textContent = 'Added ✓';
            showStatus('Added to bag.');
            openCartDrawerSafely();
          })
          .catch(function () {
            addButton.textContent = 'Unavailable';
            showStatus('This item is unavailable.');
          })
          .finally(function () {
            resetLoading(addButton, 'Add to Bag');
          });

        return;
      }

      var clearButton = safeClosest(event.target, '[data-aurelle-clear-wishlist]');
      if (clearButton) {
        event.preventDefault();
        clearWishlist();
        return;
      }

      var addAllButton = safeClosest(event.target, '[data-aurelle-add-all-wishlist]');
      if (addAllButton) {
        event.preventDefault();
        addAllAvailable(addAllButton);
      }
    });

    document.addEventListener('aurelle:wishlist-updated', function () {
      updateCounter();
      renderWishlistPage();
    });

    window.addEventListener('storage', function (event) {
      if (event.key !== KEY) return;
      updateCounter();
      renderWishlistPage();
    });
  }

  /* ================= INIT ================= */
  function init() {
    ensureHeaderCounter();
    updateCounter();
    syncWishlistButtons();
    renderWishlistPage();
    bindEvents();
    importSharedWishlist();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();